var CsActivityLogModule = /** @class */ (function () {
    function CsActivityLogModule() {
    }
    return CsActivityLogModule;
}());
export { CsActivityLogModule };
